import MyAppointments from "assets/menu-icons/MyAppointments";

const myAppointments = {
  id: 'myAppointments',
  type: 'group',
  children: [{
    id: 'myAppointments',
    title: 'Мои записи', 
    type: 'item',
    url: '/myAppointments',
    icon: MyAppointments,
    breadcrumbs: false
  }]
}

export default myAppointments;